import { render, staticRenderFns } from "./AreaDoAssociadoDashBoard.vue?vue&type=template&id=3b29a002&scoped=true&"
import script from "./AreaDoAssociadoDashBoard.vue?vue&type=script&lang=js&"
export * from "./AreaDoAssociadoDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./AreaDoAssociadoDashBoard.vue?vue&type=style&index=0&id=3b29a002&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b29a002",
  null
  
)

export default component.exports